import { _TableActionsCell, _TableAmountCell, _TableAmountInput, _TableCell, _TableDateCell, _TableHeaderCell, _TableHeaderCellDescription, _TableHeaderSortableCell, _TableMenuTriggerHeaderCell, _TableSelectCell, _TableSelectHeaderCell } from '../../../../internal';
import { createTableCell } from './utils';
export var cells = {
  HeaderCell: createTableCell(_TableHeaderCell),
  HeaderCellDescription: createTableCell(_TableHeaderCellDescription),
  HeaderSortableCell: createTableCell(_TableHeaderSortableCell),
  SelectHeaderCell: createTableCell(_TableSelectHeaderCell),
  _MenuTriggerHeaderCell: createTableCell(_TableMenuTriggerHeaderCell),
  Cell: createTableCell(_TableCell),
  AmountCell: createTableCell(_TableAmountCell),
  AmountInput: createTableCell(_TableAmountInput),
  ActionsCell: createTableCell(_TableActionsCell),
  SelectCell: createTableCell(_TableSelectCell),
  DateCell: createTableCell(_TableDateCell)
};
//# sourceMappingURL=index.js.map